import React from 'react'
import Title from '../../components/typography/title.component'
import styled from 'styled-components'
import Button from '../../components/buttons/buttons.component'
import Container from '../../components/layout/container.component'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { validateAccount } from './services/email-confirmation.service'
import { bindActionCreators } from 'redux'
import { Creators as SiteCreators } from '../../ducks/site/site'

const StyledPage = styled.div`
	flex-direction: column;
	align-items: center;
	justify-content: center;
	margin-bottom: 4.6rem;

	p {
		text-align: center;
	}

	.custom-word-break {
		display: none;
	}

	@media (max-width: 320px) {
		.custom-word-break {
			display: block;
		}
	}
`

class EmailConfirmationPage extends React.Component {
	state = {
		isValid: null,
		error: null,
		showRedirectChangePassword: false,
		redirectUrl: '',
		showRedirectModal: false,
		redirectCountdown: 5,
		// number of seconds at which the redirect should actually happen (0 means when countdown reaches 0)
		secondsToRedirect: 0,
		redirectTimeoutId: null,
	}

	componentDidMount() {
		const { hideLoading, match, location, showLoading } = this.props
		setTimeout(() => {
			showLoading()

			const userId = match.params && match.params.id
			const code =
				location.search && location.search.substring(1).replace('code=', '')

			if (!userId || !code) {
				this.setState({ isValid: false }, () => hideLoading())
				return
			}

			validateAccount(userId, code)
				.then(({ data }) => {
					if (
						data &&
						data.data &&
						data.data.changePassword &&
						data.data.url
					) {
						const targetSeconds = this.state.secondsToRedirect
						const countdownInterval = setInterval(() => {
							this.setState((prev) => {
								if (prev.redirectCountdown === targetSeconds) {
									clearInterval(countdownInterval)
									window.location.href = data.data.url
								}
								return { redirectCountdown: prev.redirectCountdown - 1 }
							})
						}, 1000)

						this.setState(
							{
								showRedirectChangePassword: true,
								redirectUrl: data.data.url,
								isValid: true,
								showRedirectModal: true,
								redirectTimeoutId: countdownInterval,
							},
							() => hideLoading()
						)

						return
					}

					this.setState(
						{
							isValid: data.success,
							error: data.success ? null : data.errors && data.errors[0],
						},
						() => hideLoading()
					)
				})
				.catch(({ response }) => {
					this.setState(
						{
							isValid: false,
							error:
								response &&
								response.data &&
								response.data.errors &&
								response.data.errors[0],
						},
						() => hideLoading()
					)
				})
		}, 100)
	}

	componentWillUnmount() {
		// Make sure we clear the redirect interval if the component unmounts
		if (this.state.redirectTimeoutId) {
			clearInterval(this.state.redirectTimeoutId)
		}
	}

	handleConfirmRedirect = () => {
		clearInterval(this.state.redirectTimeoutId)
		window.location.href = this.state.redirectUrl
	}

	handleCancelRedirect = () => {
		clearInterval(this.state.redirectTimeoutId)
		this.setState({ showRedirectModal: false })
	}

	render() {
		const {
			isValid,
			error,
			showRedirectChangePassword,
			showRedirectModal,
			redirectUrl,
		} = this.state
		const { loading } = this.props
		if (loading || isValid === null) {
			return (
				<StyledPage>
					<Container>
						<div style={{ textAlign: 'center', padding: '3rem' }}>
							<p>Validando conta, por favor aguarde...</p>
						</div>
					</Container>
				</StyledPage>
			)
		}

		return (
			<StyledPage>
				{isValid !== null && (
					<Container>
						{isValid ? (
							<React.Fragment>
								<div>
									<Title>
										Cadastro <span className="bold">confirmado</span>
									</Title>
									<p>
										Seu cadastro foi concluído e você já pode acumular
										pontos.
									</p>
									<p>
										Complete seu cadastro para aproveitar todas as
										vantagens do Muviflex!
									</p>
								</div>
								<div className="center" style={{ marginTop: 10 }}>
									<Button
										primary
										type="button"
										style={{ marginRight: 15 }}
										onClick={() =>
											this.props.history.push(`/cliente/meus-dados`)
										}>
										Meus dados
									</Button>
									<Button
										style={{ marginTop: 10 }}
										primary
										type="button"
										onClick={() =>
											this.props.history.push(`/muvicard`)
										}>
										Solicitar meu cartão Muvicard
									</Button>

									{showRedirectChangePassword && (
										<Button
											style={{ margin: 15 }}
											primary
											type="button"
											onClick={() =>
												this.setState({ showRedirectModal: true })
											}>
											Definir minha senha
										</Button>
									)}
								</div>
								{showRedirectModal && (
									<div
										style={{
											position: 'fixed',
											top: 0,
											left: 0,
											width: '100vw',
											height: '100vh',
											backgroundColor: 'rgba(0, 0, 0, 0.6)',
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'center',
											zIndex: 1000,
										}}>
										<div
											style={{
												backgroundColor: '#fff',
												padding: '2rem',
												borderRadius: '16px',
												boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
												textAlign: 'center',
												width: '90%',
												maxWidth: '420px',
												fontFamily: 'Arial, sans-serif',
											}}>
											<h3 style={{ marginBottom: '1rem' }}>
												Você será redirecionado para definir sua
												senha.
											</h3>
											<p
												style={{
													color: '#555',
													fontSize: '14px',
													marginBottom: '8px',
												}}>
												Redirecionando em{' '}
												<strong>
													{this.state.redirectCountdown}s
												</strong>
											</p>
											<p
												style={{
													fontSize: '13px',
													marginBottom: '1.5rem',
												}}>
												Caso não seja redirecionado,{' '}
												<a href={redirectUrl}>clique aqui</a>.
											</p>
											<div
												style={{
													display: 'flex',
													justifyContent: 'center',
													gap: '10px',
												}}>
												<Button
													primary
													onClick={this.handleConfirmRedirect}>
													Continuar
												</Button>
												{/* <Button 
												primary
												onClick={this.handleCancelRedirect}>
													Cancelar
												</Button> */}
											</div>
										</div>
									</div>
								)}
							</React.Fragment>
						) : (
							<div>
								<Title>
									Confirmação de <br className="custom-word-break" />{' '}
									e-mail <br />
									<span className="bold">inválida</span>
								</Title>
								{error ? (
									<p>{error}</p>
								) : (
									<p>
										Link de confirmação inválido ou token expirado{' '}
										<br />
										Entre na sua conta para reenviar o e-mail de
										confirmação.
									</p>
								)}
							</div>
						)}
					</Container>
				)}
			</StyledPage>
		)
	}
}

const mapStateToProps = (state) => ({
	loading: state.site.loading,
})

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			...SiteCreators,
			hideLoading: SiteCreators.hideLoading,
			showLoading: SiteCreators.showLoading,
		},
		dispatch
	)

const connectedEmailConfirmationPage = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(EmailConfirmationPage)
)

export { connectedEmailConfirmationPage as ModuleRootComponent }
